/* Publish by EComposer at 2026-10-21 18:04:59*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-g70yngimpmp"]=  window.__ectimmers["ecom-g70yngimpmp"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let s=document.createElement("script");s.type="text/javascript",s.innerText=i.innerText,i.src&&(s.src=i.src),t.appendChild(s),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-g70yngimpmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g70yngimpmp', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-unfdfonzsii"]=  window.__ectimmers["ecom-unfdfonzsii"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-unfdfonzsii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unfdfonzsii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-okzboap4s8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-okzboap4s8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-duiidn4dlv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-duiidn4dlv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q97uwwcxke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q97uwwcxke', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mo5qz9o5a68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mo5qz9o5a68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9jybjxtix').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9jybjxtix', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0dejk85le2z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0dejk85le2z', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0z7mi5tvo0us"]=  window.__ectimmers["ecom-0z7mi5tvo0us"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-0z7mi5tvo0us"]["rraq2tsgp"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0z7mi5tvo0us').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0z7mi5tvo0us', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eiuc78lojd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eiuc78lojd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-im2iqpz7apb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-im2iqpz7apb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8ib39c29q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8ib39c29q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzulmey8hi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzulmey8hi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}